module.exports = __webpack_public_path__ + "img/h4.e728c862.png";